/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

export const footerStyle = {
  footer: (theme: Theme) => ({
    position: "relative",
    background: theme.palette.gradients.charcoal,
    color: theme.palette.common.white,
    overflow: "hidden",
  }),
  backgroundImage: (theme: Theme) => ({
    position: "absolute",
    right: 0,
    transform: "translateX(30%)",
    pointerEvents: "none",
    [theme.breakpoints.up("lg")]: {
      transform: "translateX(20%)",
    },
  }),
  content: (theme: Theme) => ({
    padding: "2.5rem 1rem",
    justifyContent: "space-between",
    [theme.breakpoints.up("md")]: {
      padding: "4rem 6rem 10rem",
    },
  }),
  contentLoggedIn: (theme: Theme) => ({
    padding: "2.5rem 1rem",
    [theme.breakpoints.up("md")]: {
      padding: "4rem 6rem",
      justifyContent: "space-between",
    },
  }),
  links: (theme: Theme) => ({
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "2.5rem",
    margin: "2.5rem 0 0",
    [theme.breakpoints.up("lg")]: {
      gap: "5rem",
      gridTemplateColumns: "repeat(3, 1fr)",
      margin: "0 auto",
    },
  }),
  brand: {
    maxWidth: "30rem",
  },
  brandLogo: {
    marginBottom: "2.5rem",
  },
  brandLogoLoggedIn: (theme: Theme) => ({
    marginBottom: "2.5rem",
    [theme.breakpoints.up("lg")]: {
      marginBottom: 0,
    },
  }),
  meta: (theme: Theme) => ({
    alignItems: "center",
    justifyContent: "space-between",
    padding: "2rem 1rem",
    borderTopStyle: "solid",
    borderTopWidth: "1px",
    borderTopColor: theme.palette.common.white,
    [theme.breakpoints.up("md")]: {
      padding: "2rem 6rem",
    },
  }),
  linkedInLink: {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    color: "inherit",
    cursor: "pointer",
  },
};
